<template>
  <div class="app-container view-container bj-label-colon">
    <!-- 三方订单基本信息 -->
    <BjDivider right-fixed>{{ $t('SalesOrderEntry.Basic') }}
      <template slot="right">
        <template v-if="$route.query.orderHandleStatus != 3">
          <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="onConfirm">{{ $t('saveText') }}</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="cancel">{{ $t('backText') }}</el-button>
        </template>
      </template>
    </BjDivider>
    <el-form ref="form" :model="form" label-position="top" :rules="rules" label-width="160px">
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderEntry.order')" prop="orderBaseInfoDTO.outerOrderNo">
            <BjInputCode v-model="form.orderBaseInfoDTO.webReference" disabled />
          </el-form-item>
        </el-col>
        <BjSelectChannelStore :span="colSpan" :query-params="form.orderBaseInfoDTO" :query-keys="['channel', 'storeCode']" :query-props="['orderBaseInfoDTO.channel', 'orderBaseInfoDTO.storeCode']" :query-labels="[$t('SalesOrderEntry.channel'), $t('SalesOrderEntry.store')]" store-option-value="code" @handleStoreChange="onChangeStore" />
      </el-row>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderEntry.time')" prop="orderBaseInfoDTO.orderTime">
            <BjDateTimerPicker v-model="form.orderBaseInfoDTO.orderTime" />
          </el-form-item>
        </el-col>
        <!-- 客服备注 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('AddInternalRefundOnlyDoc.Customer')" prop="orderBaseInfoDTO.serviceRemarks">
            <el-input v-model="form.orderBaseInfoDTO.serviceRemarks" :maxlength="MAX_LENGTH.PRIORITY" type="textarea" show-word-limit autosize :placeholder="$t('AddInternalRefundOnlyDoc.Customer')" />
          </el-form-item>
        </el-col>
        <!-- 商家备注 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderEntry.Notes')" prop="orderBaseInfoDTO.orderRemarks">
            <el-input v-model="form.orderBaseInfoDTO.orderRemarks" :maxlength="MAX_LENGTH.PRIORITY" type="textarea" show-word-limit autosize :placeholder="$t('SalesOrderEntry.Notes')" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <!-- 运输方式 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrder2.means')" prop="orderBaseInfoDTO.shippingMethod">
            <BjSelectLov v-model="form.orderBaseInfoDTO.shippingMethod" :option-list="CSG_ORDER_SHIPPING_METHODS_LIST" @change="onChangeShippingMethod" />
          </el-form-item>
        </el-col>

        <!-- CSG MANUAL -->
        <template v-if="isCSGShow">
          <!-- 是否报价 -->
          <!-- <el-col :span="colSpan/4">
            <el-form-item :label="$t('WarehouseManagement.form.isQuotation')">
              <el-switch v-model="form.orderBaseInfoDTO.isNeedQuota" active-color="#082dc3" inactive-color=""></el-switch>
            </el-form-item>
          </el-col> -->
          <!-- 是否指定物流 -->
          <!-- <el-col :span="colSpan/4">
            <el-form-item :label="$t('WarehouseManagement.form.isLogisticsSpecified')">
              <el-switch v-model="isLogisticsSpecified" disabled active-color="#082dc3" inactive-color=""></el-switch>
            </el-form-item>
          </el-col> -->
          <!-- 物流信息 -->
          <!-- <el-col v-if="isLogisticsSpecified" :span="colSpan/2">
            <el-form-item :label="$t('WarehouseManagement.form.chooseLogistics')" prop="LogisticsSelectionDataRule">
              <BjSelectLov v-model="form.orderBaseInfoDTO.logisticsBusinessName" :disabled="!isLogisticsSpecified" :option-list="LogisticsSelectionData" @change="logsome" />
            </el-form-item>
          </el-col> -->
          <!-- 送货预约时间 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessThirdOrderAdd.deliveryAppointmentTime')">
              <BjDateTimerPicker v-model="form.orderBaseInfoDTO.deliveryAppointmentTime" />
            </el-form-item>
          </el-col>
        </template>

        <!-- CUSTOMER MANUAL -->
        <template v-if="isCustomerShow">
          <el-col :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.chooseLogistics')">
              <BjSelectLov v-model="form.orderBaseInfoDTO.logisticsBusinessName" :option-list="LogisticsSelectionData" @change="logsome" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')" prop="orderBaseInfoDTO.logisticsNo">
              <BjInput v-model="form.orderBaseInfoDTO.logisticsNo" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.need')" prop="palletQty">
              <BjInputNumber v-model="form.orderBaseInfoDTO.palletQty" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.time')" prop="truckPickupTime">
              <BjDateTimerPicker v-model="form.orderBaseInfoDTO.truckPickupTime" />
            </el-form-item>
          </el-col>
          <!-- 'CUSTOMER MANUAL' 是否需要仓库提供尺寸信息 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('WarehouseManagement.form.if')" prop="isProvideSize">
              <el-switch v-model="form.orderBaseInfoDTO.isProvideSize" active-color="#082dc3" inactive-color=""></el-switch>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
      <el-row>
        <template>
          <!-- 物流单：只有CUSTOMER MANUAL才有 -->
          <!-- shippingLabels -->
          <el-col :span="colSpan" v-show="isCustomerShow">
            <el-form-item :label="$t('OrdinaryOrderMix.LogisticsTable.Shipment')">
              <UploadFile ref="UploadFileRef1" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple show-file-list accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']" auto-upload limit-hide @handleFileListChange="fileListChange1">
                <template slot="default">
                  <el-button size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                </template>
                <template slot="tip">
                  <div class="hint">
                    <p> 1.{{$t('OrdinaryOrderMix.LogisticsTable.ps1')}}</p>
                    <p> 2.{{$t('OrdinaryOrderMix.LogisticsTable.ps2')}}</p>
                  </div>
                </template>
              </UploadFile>
            </el-form-item>
          </el-col>
          <!-- 附件 -->
          <!-- orderMaterialList -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('OrdinaryOrderMix.LogisticsTable.Supporting')">
              <UploadFile :disabled="!$store.getters.cusId" ref="UploadFileRef2" class="avatar-uploader" :limit="20" :limit-size="5 * 1024" multiple show-file-list accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']" auto-upload limit-hide @handleFileListChange="fileListChange2">
                <template slot="default">
                  <el-button :disabled="!$store.getters.cusId" size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
                </template>
                <template slot="tip">
                  <div class="hint">
                    <p> 1.{{$t('OrdinaryOrderMix.LogisticsTable.ps3')}}</p>
                  </div>
                </template>
              </UploadFile>
            </el-form-item>
          </el-col>
        </template>
      </el-row>

      <!-- 买家及收货信息 -->
      <BjDivider>{{ $t('SalesOrderEntry.Buyer') }}</BjDivider>
      <el-row>
        <!-- 收货人 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderEntry.Consignee')" prop="orderBuyerInfoDTO.receiverName">
            <BjInput v-model="form.orderBuyerInfoDTO.receiverName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 收货人手机号 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('SalesOrderEntry.phone')" prop="orderBuyerInfoDTO.mobile">
            <BjInput v-model="form.orderBuyerInfoDTO.mobile" onkeyup="this.value = this.value.replace(/[^\d]/g,'');" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 邮箱 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('ExternalOrders.newAdd.emailAddress')" prop="orderBuyerInfoDTO.deliveryEmailAddress" :rules="{ required:false, validator: this.validatorEmail, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.deliveryEmailAddress" :maxlength="MAX_LENGTH.NORMAL_REMARK" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 国家 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.form.country')" prop="orderBuyerInfoDTO.country" :rules="{ required:true, message: this.$t('chooseText'), trigger: 'change'}">
            <BjSelectLov v-model="form.orderBuyerInfoDTO.country" :option-list="COUNTRY_NAME_AND_TWOCODE" :placeholder="$t('chooseText')" />
          </el-form-item>
        </el-col>
        <!-- 洲 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.form.state')" prop="orderBuyerInfoDTO.province" :rules="{ required:false, message: this.$t('inputText'), trigger: 'blur'}" v-if="form.orderBaseInfoDTO.shippingMethod=='PICKUP' || ['TW','HK','MO','SG','GB','IE','IL','IS','AE','MC','BH','VA','SZ','MV','NZ','SM','LI','AD','BS'].includes(form.orderBuyerInfoDTO.country)">
            <BjInput v-model="form.orderBuyerInfoDTO.province" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
          <el-form-item :label="$t('WarehouseManagement.form.state')" prop="orderBuyerInfoDTO.province" :rules="{ required: true, validator: this.validatorAddress1, trigger: 'blur'}" v-else>
            <BjInput v-model="form.orderBuyerInfoDTO.province" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 市 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.form.city')" prop="orderBuyerInfoDTO.district" :rules="{ required:form.orderBaseInfoDTO.shippingMethod=='PICKUP'?false:true, validator: this.validatorAddress1, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.district" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 邮编 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('WarehouseManagement.form.postcode')" prop="orderBuyerInfoDTO.zipCode" :rules="{ required:form.orderBaseInfoDTO.shippingMethod=='PICKUP'?false:true, validator: this.validatorPostCode, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.zipCode" :maxlength="MAX_LENGTH.SHORT_NAME" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 邮寄地址1 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('ExternalOrders.newAdd.DeliveryAddress1')" prop="orderBuyerInfoDTO.deliveryAddress1" :rules="{ required:form.orderBaseInfoDTO.shippingMethod=='PICKUP'?false:true, validator: this.validatorAddress1, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.deliveryAddress1" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </el-form-item>
        </el-col>
        <!-- 邮寄地址2 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('ExternalOrders.newAdd.DeliveryAddress2')" prop="orderBuyerInfoDTO.deliveryAddress2" :rules="{ required:form.orderBaseInfoDTO.shippingMethod=='PICKUP'?false:false, validator: this.validatorAddress2, trigger: 'blur'}">
            <BjInput v-model="form.orderBuyerInfoDTO.deliveryAddress2" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('SalesOrderEntry.address')" clearable />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 商品信息 -->
      <BjDivider>{{ $t('SalesOrderEntry.Product') }}
        <template v-slot:button>
          <el-button :disabled="SELECTED_BJ_EBC_ID.length == 0 || $route.query.orderHandleStatus == 3" type="danger" @click="batchDelete">{{ $t('SalesOrderEntry.delete') }}</el-button>
          <el-button :disabled="$route.query.orderHandleStatus == 3" type="primary" @click="addGoodsDialog('dialogListOrdinarySku')">{{ $t('SalesOrderEntry.ordinary') }}</el-button>
          <el-button :disabled="$route.query.orderHandleStatus == 3" type="primary" @click="addGoodsDialog('dialogListPackAgeSku')">{{ $t('SalesOrderEntry.package') }}</el-button>
        </template>
      </BjDivider>
      <OrderItemTable ref="OrderItemTable" :table-data.sync="form.orderItemDTOList" @delete="onDelete" @selection-change="handleSelectionChange" />
    </el-form>
    <!-- 选择普通商品 -->
    <BjDialogList ref="dialogListOrdinarySku" width="80%" :config="
        $BjDialogListConfig.skuDefault($t('SalesOrderEntry.goods'), {
          defaultQuery: { setFlag: 0, status: [3, 4, 5], cusId, itemType:'item' },
        })
      " multiple @confirm="onAddGoodsDialogConfirm" />
    <!-- 选择组合商品 -->
    <BjDialogList ref="dialogListPackAgeSku" width="80%" :config="
        $BjDialogListConfig.skuDefault($t('SalesOrderEntry.Add'), {
          defaultQuery: { setFlag: 1, status: [3, 4, 5], cusId },
        })
      " multiple @confirm="onAddGoodsDialogConfirm" />
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { orderApi, channelApi, logisticApi, commonApi, goodsApi } from '@/api';
import OrderItemTable from './OrderItemTable';
import { randomID, getShippingList } from '@/utils/index';
import moment from 'moment';
import UploadFile from './UploadFile';
import { COUNTRY_NAME_AND_TWOCODE } from '@/utils/statics';

const getDefaultForm = () => {
  return {
    // 订单基础信息
    orderBaseInfoDTO: {
      webReference:null,
      channel: null,
      storeCode: null,
      orderTime: null,
      deliveryAppointmentTime: null,
      serviceRemarks: null,
      orderRemarks: null,
      shippingMethod: null,
      logisticsBusinessName: null,
      logisticsNo: null,
      palletQty: null,
      truckPickupTime: null,
      isProvideSize: false,
      shippingLabels: [],
      orderMaterialList: [],
      
      takingDeliveryWay: '2',
      actionType: '201', // (string, optional): 订单创建类型 , 手工单
      copyOrigin: null, // (string, optional): 复制来源 ,
      businessType: 'common',
      outerOrderNo: null,
      payStatus: 1,
      buyerRemarks: null, //买家备注
      storeId: null,
      storeName: null,
      salesEmployeeId: null,
      salesEmployeeRealName: null,
      salesOrganizingId: null,
      takingDeliveryStoreId: null,
      takingDeliveryStoreName: null,
    },
    // 订单买家信息
    orderBuyerInfoDTO: {
      receiverName:null,
      mobile:null,
      deliveryEmailAddress: null,
      country: null,
      province: null,
      district: null,
      zipCode: null,
      deliveryAddress1: null,
      deliveryAddress2: null,

      address: null,
      buyerNick: null,
      buyerRemarks: null,
      city: null,
      countryCode: null,
      districtCode: null,
      phone: null,
      provinceCode: null,
      town: null,
    },
    // 订单商品详情
    orderItemDTOList: [],
    // 订单支付信息
    orderPaymentInfoDTO: {
      payAmount: null,
      payTime: null,
      payType: null,
      goodsTotalAmount: null, // 订单应收总金额  取计算属性 goodsTotalAmount
      costTotalAmount: null, // 商品总成本  取计算属性 costTotalAmount
      flag: false, // 支付金额是否含运费
      transPrice: null,
    },
  };
};
export default {
  name: 'BusinessOrderInternalAdd',
  components: { OrderItemTable,UploadFile },
  mixins: [viewMiXin],
  data() {
    return {
      colSpan: 8,
      COUNTRY_NAME_AND_TWOCODE,
      isRules: false,
      CSG_ORDER_SHIPPING_METHODS_LIST: [],
      form: getDefaultForm(),
      regionList: [],
      orderDisabledList: [],
      selectedRow: [],
      /** 订单应收总金额 */
      shopTotalPrice: 0,
      // 应收总金额
      receiveTotalPrice: 0,
      onSearch: false,
      isLogisticsSpecified: false,
      isCSGShow: false,
      isCustomerShow: false,
      takingDeliveryWay: false,
      queryApi: logisticApi.getLogisticsCompany,
      LogisticsSelectionData: [],
      logisticsName: '',
      // 仓库数据
      WarehousesList: [],
      resultObject: null,
      ramakePlus: '',
      cusId: null,
      shippingLabels: [],
      orderMaterialList: [],
    };
  },
  computed: {
    SELECTED_BJ_EBC_ID() {
      return this.selectedRow.map(e => e.BJ_EBC_ID);
    },
    goodsTotalAmount() {
      let amount = 0;
      this.form.orderItemDTOList.forEach(row => {
        amount += Number(row.outerSaleAmount || 0);
      });
      return amount;
    },
    costTotalAmount() {
      let amount = 0;
      this.form.orderItemDTOList.forEach(row => {
        amount += Number(row.costPrice || 0) * Number(row.quantity || 0);
      });
      return amount;
    },
    // 表单校验
    rules() {
      const validateLogistics = (rule, value, callback) => {
        this.$nextTick(() => {
          if (this.isLogisticsSpecified && !this.logisticsName) {
            callback(new Error(this.$t('chooseText')));
          }
          callback();
        });
      };
      const validateRemarks2 = (rule, value, callback) => {
        this.$nextTick(() => {
          // if(/[^a-zA-Z0-9_#\[\]\(\)\-\s]/g.test(this.form.orderBaseInfoDTO.serviceRemarks)){
          //   callback(new Error(this.$t('inputPlusText')));
          // }
          callback();
        });
      };

      return {
        'orderBaseInfoDTO.channel': [{ required: true, message: this.$t('SalesOrderEntry.form.channel'), trigger: 'change' }],
        'orderBaseInfoDTO.storeCode': [{ required: true, message: this.$t('SalesOrderEntry.form.store'), trigger: 'change' }],
        'orderBaseInfoDTO.outerOrderNo': [{ required: true, message: this.$t('SalesOrderEntry.form.order'), trigger: 'change' }],
        'orderBaseInfoDTO.serviceRemarks': [{ required: true, validator: validateRemarks2, trigger: 'blur' }],
        'orderBaseInfoDTO.orderTime': [{ required: true, message: this.$t('SalesOrderEntry.form.ordering'), trigger: 'change' }],
        'orderBaseInfoDTO.businessType': [{ required: true, message: this.$t('SalesOrderEntry.form.type'), trigger: 'change' }],
        'orderBaseInfoDTO.shippingMethod': [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        'orderBuyerInfoDTO.receiverName': [{ required: true, message: this.$t('SalesOrderEntry.form.consignee'), trigger: 'change' }],
        'orderBuyerInfoDTO.mobile': [{ required: true, message: this.$t('SalesOrderEntry.form.number'), trigger: 'change' }],
        'orderPaymentInfoDTO.payType': [{ required: true, message: this.$t('SalesOrderEntry.form.payment'), trigger: 'change' }],
        'orderPaymentInfoDTO.payAmount': [{ required: true, message: this.$t('SalesOrderEntry.form.amount'), trigger: 'change' }],
        'orderBaseInfoDTO.payStatus': [{ required: true, message: this.$t('SalesOrderEntry.form.status'), trigger: 'change' }],
        'orderPaymentInfoDTO.payTime': [{ required: true, message: this.$t('SalesOrderEntry.form.time'), trigger: 'change' }],
        LogisticsSelectionDataRule: { required: this.isRules, validator: validateLogistics, trigger: 'change' },
      };
    },
  },
  watch: {
    /** 是否开启三方平台活动 */
    'form.orderPaymentInfoDTO.flag': {
      handler() {
        this.form.orderPaymentInfoDTO.transPrice = 0.0;
      },
    },
    regionList(value) {
      this.form.orderBuyerInfoDTO.countryCode = (value || [])[0];
      this.form.orderBuyerInfoDTO.provinceCode = (value || [])[1];
    },
  },
  created() {
    // 获取仓库数据
    this._getListWarehouses();
  },
  mounted() {
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'innerOrderNo')) {
      if(this.$route.query.orderHandleStatus == 3){
        getShippingList(this.$route.query.cusId).then(res=>{
          this.CSG_ORDER_SHIPPING_METHODS_LIST = res.filter(item=> !item.isDisable)
          this.getEditingDate()
          console.log('getEditingDate')
        })
      }else{
        this.initApi()
        console.log('initApi')
      }
    }
  },
  methods: {
    // 邮箱校验  
    validatorEmail(rule, value, callback) {
      if (!value) {
        callback();
      } else if (value && !value.includes('@')){
        callback(new Error(this.$t('personal.emailErrorMsg2')));
      } else {
        callback();
      }
    },
    // 邮编校验  
    validatorPostCode(rule, value, callback) {
      if(this.form.orderBaseInfoDTO.shippingMethod == 'PICKUP'){
        if (value) {
          callback(new Error(this.$t('ExternalOrders.addressTips')));
        } else {
          callback();
        }
      }else{
        if (!value) {
          callback(new Error(this.$t('inputText')));
        } else {
          callback();
        }
      }
    },
    // 地址1校验
    validatorAddress1(rule, value, callback) {
      const regex = /^[A-Za-z0-9 \-\'\.,\/#&:;()]+$/
      if(this.form.orderBaseInfoDTO.shippingMethod == 'PICKUP'){
        if (value) {
          callback(new Error(this.$t('ExternalOrders.addressTips')));
        } else {
          callback();
        }
      }else{
        if (!value) {
          callback(new Error(this.$t('inputText')));
        } else if(!regex.test(value)){
          callback(new Error(this.$t('IncorrectAddressFormatText')));
        } else {
          callback();
        }
      }
    },
    // 地址2校验 ： 非必填，如果填写就要符合规范
    validatorAddress2(rule, value, callback) {
      const regex = /^[A-Za-z0-9 \-\'\.,\/#&:;()]+$/
      if(this.form.orderBaseInfoDTO.shippingMethod == 'PICKUP'){
        if (value) {
          callback(new Error(this.$t('ExternalOrders.addressTips')));
        } else {
          callback();
        }
      }else{
        if (!value) {
          callback();
        } else if (!regex.test(value)){
          callback(new Error(this.$t('IncorrectAddressFormatText')));
        } else {
          callback();
        }
      }
    },
    // 上传的文件列表
    fileListChange1(file) {
      if(file.length > 0){
        this.shippingLabels = file&&file.map(item => { return {name: item.name,  url: item.url}}).filter(item => item.url);
      }else{
        this.shippingLabels = []
      }
    },
    // 上传的文件列表 
    fileListChange2(file) {
      if(file.length > 0){
        this.orderMaterialList = file&&file.map(item => { return {fileName: item.name,  fileUrl: item.url}}).filter(item => item.fileUrl);
      }else{
        this.orderMaterialList = []
      }
    },
    getEditingDate(){
      let promise = Promise.resolve();
      orderApi.getLogPage({innerOrderNo: this.$route.query.innerOrderNo, action: 'ORDER_EDIT'}).then(async res =>{
        const dataRes = JSON.parse(res.content[0].curValue)
        // 获取skuName
        await goodsApi.getSku2(dataRes.orderItemDTOList.map(e=>e.skuCode)).then(res => {
          dataRes.orderItemDTOList.forEach(item =>{
            promise = promise.then(() => {
              return new Promise(resolve => {
                orderApi.selectSkuCodeBatch({skuCode: item.skuCode, cusId:this.$route.query.cusId}).then(resp=>{
                    res.forEach(jitem=>{
                      if(item.skuCode == jitem.skuCode){
                        item.id = item.skuId;
                        item.giftFlag = String(item.giftFlag);
                        item.BJ_EBC_ID = randomID();
                        item.BJ_HAS_CHILD = !!item.setMealFlag;
                        item.BJ_PARENT_ID = null;
                        item.isChildSku = false;
                        item.skuName = jitem.skuName;
                        // item.spuCode = jitem.spuCode;
                        item.batchNumList = resp.map(kitem=>{return { //批次号
                          value: kitem.batchNum, label: kitem.batchNum, usableNum:kitem.usableNum, bbd:kitem.bbd
                        }})
                      }
                    })
                    resolve();
                })
              })
            })
          })
          this.isCSGShow = dataRes.orderBaseInfoDTO.shippingMethod == 'CSG MANUAL';
          this.isCustomerShow = dataRes.orderBaseInfoDTO.shippingMethod == 'CUSTOMER MANUAL';
          this.getDataOfSearch(dataRes.orderBaseInfoDTO.shippingMethod)
          this.form.orderBaseInfoDTO.logisticsBusinessName = dataRes.orderBaseInfoDTO.logisticsBusinessName;
          this.form.orderBaseInfoDTO.logisticsNo = dataRes.orderBaseInfoDTO.logisticsNo;
          this.isLogisticsSpecified = dataRes.orderBaseInfoDTO.isLogisticsSpecified == 1 ? true : false;
          this.logisticsName = dataRes.orderBaseInfoDTO.logisticsName;
          this.ramakePlus = dataRes.orderBaseInfoDTO.orderRemarks || '';
          // 附件组件回显
          this.$refs.UploadFileRef2.fileList = dataRes.orderBaseInfoDTO.orderMaterialList?.map(item=>{
            return {
              name: item.fileName,
              url: item.fileUrl
            };
          });
          if(dataRes.orderBaseInfoDTO.shippingMethod == 'CUSTOMER MANUAL'){
            // 物流单组件回显
            this.$refs.UploadFileRef1.fileList = JSON.parse(dataRes.orderBaseInfoDTO.shippingLabels)
          }
          dataRes.orderBaseInfoDTO.orderTime = moment(dataRes.orderBaseInfoDTO.orderTime).format('YYYY-MM-DD HH:mm:ss');
          dataRes.orderBaseInfoDTO.deliveryAppointmentTime = dataRes.orderBaseInfoDTO.deliveryAppointmentTime
            ? moment(dataRes.orderBaseInfoDTO.deliveryAppointmentTime).format('YYYY-MM-DD HH:mm:ss')
            : null;
          dataRes.orderBuyerInfoDTO.mobile = dataRes.orderBuyerInfoDTO.mobile ? dataRes.orderBuyerInfoDTO.mobile : dataRes.orderBuyerInfoDTO.phone;
          return promise.then(() => {
            this.$message.success(this.$t('SalesOrderEntry.form.obtained'));
            this.form = Object.assign(getDefaultForm(), { ...dataRes });
            this.reSetTable();
          })
        });
      })
    },
    initApi(){
      let promise = Promise.resolve();
      const innerOrderNo = this.$route.query.innerOrderNo;
      orderApi.addInternalOrderByCopy({ innerOrderNo }).then(async res => {
        let GoodsList = [];
        if (res && res.itemVOList) {
          // 获取网店详情 和 所用的id
          await this.getOnlineShop(res.orderBaseInfoDTO.storeId,res.orderBaseInfoDTO.takingDeliveryWay);
          await res.itemVOList.forEach(e => {
            promise = promise.then(() => {
              return new Promise(resolve => {
                orderApi.selectSkuCodeBatch({skuCode: e.skuCode,cusId:this.cusId}).then(resp=>{
                  GoodsList.push({
                    ...e,
                    id: e.skuId,
                    giftFlag: String(e.giftFlag),
                    BJ_EBC_ID: randomID(),
                    BJ_HAS_CHILD: !!e.setMealFlag,
                    BJ_PARENT_ID: null,
                    isChildSku: false,
                    spuCode: e.spuCode,
                    batchNumList: resp.map(item=>{return { //批次号
                      value: item.batchNum, label: item.batchNum, usableNum:item.usableNum, bbd:item.bbd
                    }}),
                  });
                  resolve();
                })
              })
            })
          });
          return promise.then(() => {
            if (!res.failed) {
              this.$message.success(this.$t('SalesOrderEntry.form.obtained'));
              res.orderBaseInfoDTO.deliveryAppointmentTime = res.orderBaseInfoDTO.deliveryAppointmentTime
                ? moment(res.orderBaseInfoDTO.deliveryAppointmentTime).format('YYYY-MM-DD HH:mm:ss')
                : null;
              this.form = Object.assign(getDefaultForm(), { ...res, orderItemDTOList: GoodsList });
              this.getDataOfSearch(this.form.orderBaseInfoDTO.shippingMethod)
              this.form.orderBaseInfoDTO.logisticsBusinessName = res.orderBaseInfoDTO.logisticsBusinessName;
              this.form.orderBaseInfoDTO.logisticsNo = res.orderBaseInfoDTO.logisticsNo;
              this.form.orderBaseInfoDTO.actionType = '202'; // constants.js => ORDER_ACTION_TYPE_LIST => 复制单
              this.form.orderBaseInfoDTO.copyOrigin = this.$route.query.innerOrderNo;
              this.logisticsName = res.orderBaseInfoDTO.logisticsName;
              this.ramakePlus = res.orderBaseInfoDTO.orderRemarks || '';
              // 附件组件回显
              this.$refs.UploadFileRef2.fileList = res.orderBaseInfoDTO.orderMaterialList.map(item=>{
                return {
                  name: item.fileName,
                  url: item.fileUrl
                };
              });
              if (res.orderBaseInfoDTO.shippingMethod == 'CSG MANUAL') {
                this.isLogisticsSpecified = true;
                this.isCSGShow = true;
              }
              if (res.orderBaseInfoDTO.shippingMethod == 'CUSTOMER MANUAL') {
                this.isCustomerShow = true;
                // 物流单组件回显
                this.$refs.UploadFileRef1.fileList = res.orderBaseInfoDTO.shippingLabels?JSON.parse(res.orderBaseInfoDTO.shippingLabels):[]
              }
              this.form.orderBuyerInfoDTO.mobile = res.orderBuyerInfoDTO.mobile ? res.orderBuyerInfoDTO.mobile : res.orderBuyerInfoDTO.phone;
              this.regionList = [
                Number(res.orderBuyerInfoDTO.countryCode),
                Number(res.orderBuyerInfoDTO.provinceCode),
              ];
            }
            this.reSetTable();
          });
        }
      });
    },
    onChangeShippingMethod(val) {
      // 清空物流单组件数据
      this.$refs['UploadFileRef1'].fileList = [];
      // 清空物流单参数数据
      this.shippingLabels = [];
      // 清空附件组件数据
      this.$refs['UploadFileRef2'].fileList = [];
      // 清空附件参数数据
      this.orderMaterialList = [];
      this.form.orderBaseInfoDTO.logisticsBusinessName = null;
      this.form.orderBaseInfoDTO.logisticsNo = null;
      this.form.orderBaseInfoDTO.logisticsCompany = null;
      this.form.orderBaseInfoDTO.deliveryAppointmentTime = null;
      this.isCSGShow = false;
      this.logisticsName = null;
      this.isLogisticsSpecified = false;
      this.form.orderBaseInfoDTO.takingDeliveryWay = '1';
      this.isCustomerShow = false;
      this.form.orderBaseInfoDTO.buyerRemarks = '';
      if (val === 'CSG MANUAL') {
        this.form.orderBaseInfoDTO.buyerRemarks = 'CSG manual booking';
        this.isCSGShow = true;
        this.isLogisticsSpecified = true;
      } else if (val === 'CUSTOMER MANUAL') {
        this.form.orderBaseInfoDTO.buyerRemarks = 'Shipping label print';
        this.isCustomerShow = true;
      } else if (val === 'PICKUP') {
        this.form.orderBaseInfoDTO.takingDeliveryWay = '1';
      } else {
        this.form.orderBaseInfoDTO.takingDeliveryWay = '2';
      }
      this.getDataOfSearch(val)
    },
    // 获取网店详情
    getOnlineShop(storeId) {
      return new Promise((resolve) => {
        channelApi.getOnlineShopDetails({ id: storeId }).then(res => {
          this.cusId = res.cusId
          getShippingList(res.cusId).then(resp=>{
            this.CSG_ORDER_SHIPPING_METHODS_LIST = resp.filter(item=> !item.isDisable)
            resolve()
          })
        });
      })
    },
    // 获取仓库数据
    _getListWarehouses() {
      commonApi.getListWarehouses({
        code: null,
        name: null,
        typeCode: null,
        status: 1,
      }).then(res => {
        this.WarehousesList = Array.isArray(res) ? res : [];
        function search(nameKey, myArray) {
          for (var i = 0; i < myArray.length; i++) {
            if (myArray[i].name === nameKey) {
              return myArray[i].id;
            }
          }
        }
        var a = this.WarehousesList;
        this.resultObject = search('实仓', a);
      });
    },
    logsome(v, item) {
      this.logisticsName = v;
      this.form.orderBaseInfoDTO.logisticsCompany = v ? item.label: '';
    },
    // 获取物流下拉信息
    async getDataOfSearch(val) {
      logisticApi.getLogisticsBusiness({
        name: null,
        companyId: null,
        enableFlag: null,
        csgEnableFlag: val=='CSG MANUAL' ? true: null,
        currentPage: 0,
        page: 0,
        pagesize: 999,
        size: 999,
      }).then(res => {
        this.LogisticsSelectionData = res.content.map(item => {
          return { label: item.logisticsName, value: item.name }
        });
      });
    },

    reSetTable() {
      this.$nextTick(() => {
        this.$refs.OrderItemTable.reFresh();
      });
    },
    onChangeStore(v, item) {
      this.form.orderBaseInfoDTO.storeId = item.id;
      this.form.orderBaseInfoDTO.storeName = item.name;
      this.form.orderBaseInfoDTO.salesEmployeeId = null;
      this.form.orderBaseInfoDTO.salesEmployeeRealName = null;
      this.form.orderBaseInfoDTO.takingDeliveryStoreId = null;
      this.form.orderBaseInfoDTO.takingDeliveryStoreName = null;
      this.form.orderBaseInfoDTO.salesOrganizingId = item.salesOrganizingId;
    },
    batchDelete() {
      this.$confirm(this.$t('SalesOrderEntry.form.sure'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        this.SELECTED_BJ_EBC_ID.forEach(BJ_EBC_ID => {
          const index = this.form.orderItemDTOList.findIndex(e => e.BJ_EBC_ID == BJ_EBC_ID);
          if (index > -1) this.form.orderItemDTOList.splice(index, 1);
        });
        this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
        this.reSetTable();
      });
    },
    onDelete(row) {
      this.$confirm(this.$t('SalesOrderEntry.form.want'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        const index = this.form.orderItemDTOList.findIndex(e => e.BJ_EBC_ID == row.BJ_EBC_ID);
        if (index > -1) this.form.orderItemDTOList.splice(index, 1);
        this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
        this.reSetTable();
      });
    },
    handleSelectionChange(d) {
      this.selectedRow = [].concat(d.selection);
    },
    addGoodsDialog(REF_NAME = 'dialogListOrdinarySku') {
      // TODO: 校验 ？ 赠品之类的
      this.orderDisabledList = this.form.orderItemDTOList
        .filter(e => e.giftFlag == 0)
        .map(e => e.id);
      this.$refs[REF_NAME].show();
    },
    onAddGoodsDialogConfirm(data) {
      if (data && !data[0].id) return;
      let promise = Promise.resolve();
      data.forEach(async(item) => {
        // if (!this.form.orderItemDTOList.find(ee => ee.skuCode == item.skuCode)) {
          promise = promise.then(() => {
              return new Promise(resolve => {
                orderApi.selectSkuCodeBatch({skuCode: item.skuCode,cusId: this.cusId}).then(async resp=>{
                    this.form.orderItemDTOList.push({
                      id: item.id,
                      skuId: item.id,
                      skuName: item.skuName,
                      skuCode: item.skuCode,
                      spuCode: item.spuCode,
                      standardSkuCode: item.standardSkuCode,
                      quantity: 1,
                      giftFlag: '0',
                      transPrice: undefined,
                      outerSingleSaleAmount: Number(item.salesPrice) || undefined,
                      outerSaleAmount: Number(item.salesPrice) || undefined,
                      innerSingleSaleAmount: Number(item.salesPrice) || '',
                      innerSaleAmount: Number(item.salesPrice) || '',
                      setMealFlag: item.setFlag,
                      // 老传参，暂时搁置
                      // id: item.id,
                      // spuName: item.spuName,
                      // costPrice: Number(item.costPrice) || '',
                      BJ_EBC_ID: randomID(),
                      // BJ_HAS_CHILD: !!item.setFlag,
                      // BJ_PARENT_ID: null,
                      // isChildSku: false,
                      batchNumList: resp.map(item=>{return { //批次号
                        value: item.batchNum, label: item.batchNum, usableNum:item.usableNum, bbd:item.bbd
                      }}),
                    });
                    resolve();
                });
              })
            })
        // }
      });
      return promise.then(() => {
        this.reSetTable();
      });
    },
    /** 确定 */
    onConfirm() {
      this.$refs.form.validate(valid => {
        if(valid){
          if (this.form.orderPaymentInfoDTO.payTime < this.form.orderBaseInfoDTO.orderTime) {
            this.$message.warning(this.$t('SalesOrderEntry.form.cannot'));
            return;
          }
          if (this.form.orderItemDTOList.length == 0) {
            this.$message.error(this.$t('BusinessPurchaseOrder2.dialog.errMsg4'));
            return;
          }
          if (this.form.orderItemDTOList.some(e => e.quantity==0)) {
            this.$message.warning(this.$t('SalesOrderEntry.form.Qty'));
            return;
          }
          // 老CUSTOMER MANUAL逻辑
          // if(this.form.orderBaseInfoDTO.shippingMethod === 'CUSTOMER MANUAL'){
          //   if(this.form.orderBaseInfoDTO.logisticsNo && !this.form.orderBaseInfoDTO.logisticsBusinessName) return this.$message.error(this.$t('BusinessPurchaseComponentsCom.rules.logisticsBusinessId'));
          // }

          // 新CUSTOMER MANUAL逻辑
          if(this.form.orderBaseInfoDTO.shippingMethod == 'CUSTOMER MANUAL'){
            // 若不需要仓库提供尺寸信息 则此处 Courier Service，Job Id/Tracking No.，Shipping Label都应为必填
            if(this.form.orderBaseInfoDTO.isProvideSize == false){
              if(!this.form.orderBaseInfoDTO.logisticsBusinessName){
                return this.$message.error(`${this.$t('inputText')} ： ${this.$t('WarehouseManagement.form.chooseLogistics')}`);
              }
              if(!this.form.orderBaseInfoDTO.logisticsNo){
                return this.$message.error(`${this.$t('inputText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')}`);
              }
              if(this.shippingLabels.length==0){
                return this.$message.error(`${this.$t('chooseText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.Shipment')}`);
              }
            }
            // 如果Courier Service，Job Id/Tracking No.，Shipping Label任意一个有值，那么另外两个都必填
            if(this.form.orderBaseInfoDTO.logisticsBusinessName || this.form.orderBaseInfoDTO.logisticsNo || this.shippingLabels.length!=0){
              if(!this.form.orderBaseInfoDTO.logisticsBusinessName){
                return this.$message.error(`${this.$t('inputText')} ： ${this.$t('WarehouseManagement.form.chooseLogistics')}`);
              }
              if(!this.form.orderBaseInfoDTO.logisticsNo){
                return this.$message.error(`${this.$t('inputText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')}`);
              }
              if(this.shippingLabels.length==0){
                return this.$message.error(`${this.$t('chooseText')} ： ${this.$t('OrdinaryOrderMix.LogisticsTable.Shipment')}`);
              }
            }
            // 老逻辑保留
            if(this.shippingLabels.length>0 && this.form.orderBaseInfoDTO.isProvideSize == true){this.form.orderBaseInfoDTO.isProvideSize = false};
          }

          // 物流单传参
          this.form.orderBaseInfoDTO.shippingLabels = this.shippingLabels.length>0 ? JSON.stringify(this.shippingLabels) : null,
          // 附件传参
          this.form.orderBaseInfoDTO.orderMaterialList = this.orderMaterialList

          const POST_DATA = this.$lodash.clone(this.form);

          // let bstop = true
          const duplicates = new Map();
          const newArr = [];
          POST_DATA.orderItemDTOList.forEach(item=>{
            const key = `${item.standardSkuCode}-${item.spuCode}`;
            if (duplicates.has(key)) {
                newArr.push(item);
            } else {
                duplicates.set(key, true);
            }
            // if(item.spuCode && item.quantity > item.batchNumList.bjGet(item.spuCode, 'value', 'usableNum')){
            //   bstop = false
            // };
          })
          if(newArr.length > 0) return this.$message.warning(`${newArr[0].standardSkuCode} ${this.$t('dataDuplication')}`)
          // if(!bstop) this.$message.error('Quantity > Available')

          POST_DATA.orderItemDTOList = POST_DATA.orderItemDTOList.map(e => {
            return {
              skuId: e.skuId, // (integer, optional): skuId
              skuCode: e.skuCode, // (string, optional): sku编码 ,
              skuName: e.skuName, // 同sku编码
              spuCode: e.spuCode,
              giftFlag: e.giftFlag,
              innerSkuCode: e.skuCode,
              standardSkuCode: e.standardSkuCode,
              quantity: e.quantity - 0, // (integer, optional): 数量 ,
              transPrice: e.transPrice || 0,
              outerSingleSaleAmount: Number(e.outerSingleSaleAmount) || 0,
              outerSaleAmount: e.outerSaleAmount || 0, // (number, optional): 外部销售总价  ,
              innerSingleSaleAmount: e.innerSingleSaleAmount || 0,
              innerSaleAmount: e.innerSaleAmount || 0,
              setMealFlag: e.setMealFlag,
            };
          });
          // 订单应收总金额
          POST_DATA.orderPaymentInfoDTO.goodsTotalAmount = this.goodsTotalAmount;
          // 商品总成本
          POST_DATA.orderPaymentInfoDTO.costTotalAmount = this.costTotalAmount;
          // 买家实付总金额
          POST_DATA.orderPaymentInfoDTO.payAmount = this.goodsTotalAmount;
          // 加入是否指定物流
          POST_DATA.orderBaseInfoDTO.isLogisticsSpecified = this.isLogisticsSpecified ? '1' : '0';
          // // 是否需要仓库提供尺寸信息
          // POST_DATA.orderBaseInfoDTO.isProvideSize = this.isProvideSize;
          // 预计取货时间
          POST_DATA.orderBaseInfoDTO.truckPickupTime = this.form.orderBaseInfoDTO.truckPickupTime ? moment(this.form.orderBaseInfoDTO.truckPickupTime).format('YYYY-MM-DD HH:mm:ss') : null;
          // 送货预约时间
          POST_DATA.orderBaseInfoDTO.deliveryAppointmentTime = this.form.orderBaseInfoDTO.deliveryAppointmentTime ? moment(this.form.orderBaseInfoDTO.deliveryAppointmentTime).format('YYYY-MM-DD HH:mm:ss') : null;
          // 物流公司名称
          POST_DATA.orderBaseInfoDTO.logisticsName = this.logisticsName;
          // 手机号赋值
          POST_DATA.orderBuyerInfoDTO.phone = POST_DATA.orderBuyerInfoDTO.mobile;

          if (this.isCSGShow) { // 运输方式为CSG MANUAL BOOKING 时清空相关上送
            POST_DATA.orderBaseInfoDTO.isNeedQuota = null;
            POST_DATA.orderBaseInfoDTO.isLogisticsSpecified = null;
            POST_DATA.orderBaseInfoDTO.logisticsBusinessName = null;
          }
          this.$emit('onSave', POST_DATA);
        }
      });
    },
    // 父组件使用
    dataClear() {
      this.$message.success(this.$t('toast.operationSuccessText'));
      this.form = getDefaultForm();
      setTimeout(() => {
        const view = this.$route;
        this.$router.go(-1);
        this.$store.dispatch('tagsView/closeCurrentView', view).then(() => {
          setTimeout(() => {
            const targetPage = this.$route.name;
            if (targetPage) {
              this.$eventHub.$emit('refresh' + targetPage, 1);
            }
          }, 500);
        });
      }, 500);
    },
  },
};
</script>
<style lang="scss" scoped>
.bottom .el-form-item {
  margin-bottom: 0;
}
.price {
  font-size: 16px;
  font-weight: bold;
}
</style>
